import * as type from "../types";
import { openSnackbarInfoDispatch } from './requestAction';
import t from "../../languages/pl";
import { get, post, deleteReq, patch } from "../../config/Requests";
import {setData, setGroupsData} from '../helpers';
import { apiCarGroupId } from '../../utils/staticData';
import { mapFilterData } from './filterActions';
import { groupsListRoute, groupsCarsListRoute } from '../../config/routes';

export const changeGroupState = (newGroup) => {
    return (dispatch, getState) => {
        let store = getState().groupReducer;
        let newGroups = store.groups.map(group => {
            if(group.grupa_id === newGroup.grupa_id)
                return newGroup;
            return group;
        });
        let data = {
            nazwa: newGroup.grupa_nazwa,
            opis: newGroup.grupa_opis,
            mpp: newGroup.mpp,
            mnu: newGroup.mnu,
            mprpu: newGroup.mprpu,
            mpr: newGroup.mpr,
            rezerwa: newGroup.rezerwa,
            przekroczenie_granicy: newGroup.przekroczenie_granicy,
        };

        patch(
            dispatch,
            groupsListRoute,
            {grupa_id: newGroup.grupa_id},
            data,
            () => {
                dispatch({
                    type: type.SET_GROUPS,
                    value: newGroups
                });
                openSnackbarInfoDispatch(dispatch, t.groupsEditedMsg);
            }
        );
    };
};

export const addGroup = (name) => {
    return (dispatch) => {

        post(
            dispatch,
            groupsListRoute,
            { nazwa: name },
            response => {
                dispatch({
                    type: type.ADD_GROUP,
                    id: response.data.grupa_id,
                    name: name
                });
                // const newGroupOption = {
                //     id: response.data.grupa_id,
                //     name: name
                // };
                // const updatedgroupOptions = groupOptions.concat(newGroupOption);
                // dispatch({
                //     type: type.SET_GROUPS_FILTER,
                //     value: mapFilterData(updatedgroupOptions, apiCarGroupId, "grupa_nazwa")
                // });
            }
        );
    };
};

export const deleteGroup = id => {
    return (dispatch, getState) => {
        let store = getState().groupReducer;
        let newGroups = store.groups.filter(group => group.grupa_id !== id);
        deleteReq(
            dispatch,
            groupsListRoute,
            { grupa_id: id },
            () => {
                dispatch({
                    type: type.SET_GROUPS,
                    value: newGroups
                });
                dispatch({
                    type: type.SET_GROUPS_FILTER,
                    value: mapFilterData(newGroups, apiCarGroupId, "grupa_nazwa")
                });
                openSnackbarInfoDispatch(dispatch, t.groupDeletedMsg);
            }
        );
    };
};

export const getGroups = () => {
    return dispatch => {
        get(
            dispatch,
            groupsListRoute,
            { },
            response => {
                setGroupsData(dispatch, type.SET_GROUPS, response);
            }
        );
    };
};

export const getCarsInGroup = (id) => {
    let params = {
        grupa_id: id
    };
    return dispatch => {
        get(
            dispatch,
            groupsCarsListRoute,
            params,
            response => {
                setData(dispatch, type.SET_GROUP_CARS, response);
            }
        );
    };
};

export const patchCarsInGroup = (groupId, carIds, groupName) => {
    return (dispatch, getState) => {
        let store = getState().groupReducer;
        let newCars = store.cars.filter(car => carIds.includes(car.auto_id));
        let cars = getState().carsReducer.cars;
        let groups = store.groups.map(group => {
            if (group.grupa_id === groupId)
                group.grupa_liczba_aut = carIds.length;
            return group;
        });
        patch(
            dispatch,
            groupsCarsListRoute,
            { grupa_id: groupId },
            { auto_id: carIds },
            () => {
                dispatch({
                    type: type.SET_GROUPS,
                    value: groups
                });
                let updatedGroupWithCars = [];
                cars.map(car => {
                    car.grupy = car.grupy.filter(group => group.grupa_id !== groupId);
                    if (carIds.includes(car.auto_id)) {
                        car.grupy.push({ grupa_id: groupId, grupa: groupName });
                        updatedGroupWithCars.push({
                            auto_id: car.auto_id,
                            marka: car.marka,
                            model: car.model,
                            opis: car.opis,
                            rejestracja: car.rejestracja
                        });
                    }
                });
                const updatedCars = cars.concat();
                dispatch({
                    type: type.SET_GROUP_CARS,
                    value: updatedGroupWithCars
                });
                dispatch({
                    type: type.SET_CARS,
                    value: updatedCars
                });
                openSnackbarInfoDispatch(dispatch, t.carsAddedToGroup);
            }
        );
    };
};
